// extracted by mini-css-extract-plugin
export default {"title":"Labs_title__ys4Xs","text":"Labs_text__u2ZAU","status":"Labs_status__q+7pm"};